import { useCallback, useContext, useState } from "react";
import InventariosService from "../api/inventarios.api";
import { StateContext } from "../../../components/context/StateProvider";
import Toasts from "../../../components/notificacion/Toasts";

/**
 * Hook para el flujo "Marcar como revisado" (modal de confirmación + petición + toast)
 * @param {{ inventario: Object|null, onRevisado: (actualizado: Object) => void }} opciones
 * @returns {{ abierto: boolean, revisando: boolean, abrir: Function, cerrar: Function, confirmar: Function }}
 */
export const useRevisarInventario = ({ inventario, onRevisado }) => {
    const { state, updateState, refrescarContadorInventarios } = useContext(StateContext);
    const [abierto, setAbierto] = useState(false);
    const [revisando, setRevisando] = useState(false);

    const abrir = useCallback(() => setAbierto(true), []);
    const cerrar = useCallback(() => { if (!revisando) setAbierto(false); }, [revisando]);

    const confirmar = useCallback(async () => {
        setRevisando(true);
        try {
            const actualizado = await InventariosService.revisar(inventario.id);
            onRevisado(actualizado);
            refrescarContadorInventarios?.();
            updateState({ toasts: [...state.toasts, Toasts.generateToast("Inventario marcado como revisado", "success")] });
            setAbierto(false);
        } catch (err) {
            updateState({
                toasts: [...state.toasts, Toasts.generateToast(err.message || "No se pudo marcar como revisado.", "error")],
            });
        } finally {
            setRevisando(false);
        }
    }, [inventario, onRevisado, refrescarContadorInventarios, state.toasts, updateState]);

    return { abierto, revisando, abrir, cerrar, confirmar };
};
